import _ajaxCall from '../common/ajaxcall';
import * as Base from '../base/mbase';
import * as Str from '../base/string';
import Ajax from '../base/ajax.js';
import Dom from '../base/mdom.js';
import wxBridge from '../jsapis/openUrl';
import Env from '../common/env';
import UiSrc from '../common/uiutil.src.js';
import UiPop from '../common/uiutil.popup.src.js';

export var extend = function (defaults, options) {
    var extended = {};
    var prop;
    for (prop in defaults) {
        if (Object.prototype.hasOwnProperty.call(defaults, prop)) {
            extended[prop] = defaults[prop];
        }
    }
    for (prop in options) {
        if (Object.prototype.hasOwnProperty.call(options, prop)) {
            extended[prop] = options[prop];
        }
    }
    return extended;
};

export var extendDeep = function() {
    var len = arguments.length;
    var extended = {};

    for (var i = 0; i < len; i++) {
        for (var key in arguments[i]) {
            extended[key] = arguments[i][key]
        }
    }

    return extended;
}

export var UI      = extend(UiSrc, UiPop)



// 终端信息
function getClientInfo() {
    if(!Env.isCSR) {
        var isDebug = location.search.indexOf('debug=1') !== -1;
    
        return {
            isIOS: Env.isIOS,
            isPad: Env.isPad,
            isAndroid: Env.isAndroid,
            isWechat: Env.isWechat,
            isDebug: isDebug,
            wxVersion: Env.clientVersion(true),
            isWPcWechat: Env.isWPcWechat,
            isPC: Env.isPC
        }
    }else{
        return {
            isIOS: false, // TODO: 只灰安卓
            isPad: false,
            isAndroid: true,
            isWechat: true,
            isDebug: false,
            wxVersion: Env.clientVersion(true),
            isWPcWechat: false,
            isPC: false
        }
    }
}

// 微信webview里面设置document的 title （hack）,用之前先授权setPageTitle
export function setTitle(str) {
    var clientInfo = getClientInfo();
    function setTitleByJsAPI() {
        WeixinJSBridge.invoke('setPageTitle', {
            'title': str
        }, function (res) {
            // alert(JSON.stringify(res));
        });
    }
    // 去掉安卓的限制，安卓下也使用JSapi设置title
    if (clientInfo.isWechat) {
        if (isBigClientVersion('6.0.2') &&
            (clientInfo.isAndroid || (window.__wxjs_is_wkwebview === 'yes' || window.__wxjs_is_wkwebview))) {

            if (Dom.window.WeixinJSBridge) {
                setTitleByJsAPI();
            } else {
                document.addEventListener('WeixinJSBridgeReady', function () {
                    setTitleByJsAPI();
                });

                document.title = str;
            }
            return;
        }

        document.title = str;

        if (clientInfo.isWPcWechat) {
            return;
        }

        if ( clientInfo.isIOS ) {
            var iframe = document.createElement('iframe');
            iframe.style.cssText = 'width:0px;height:0px;display:none;';
            iframe.src = location.protocol + '//wximg.gtimg.com/tmt/game/dist/img/wgui/placeholder/1x1.png';
            iframe.onload = function () {
                setTimeout(function () {
                    iframe.onload = null;
                    document.body.removeChild(iframe);
                }, 0);
            };
            document.body.appendChild(iframe);
        }
        
    } else {
        document.title = str;
    }
}

// 节流函数，减少函数的调用次数
export function throttle(callback, t, context) {
    var timer;

    return function () {
        var args = arguments;

        clearTimeout(timer);

        return timer = setTimeout(function () {
            callback.apply(context, args);
            timer = null;
        }, t);
    }
}

export function debounce(callback, t, context) {
    var timer;

    return function () {
        var args = arguments;

        if (timer) {
            return;
        }

        timer = setTimeout(function () {
            callback.apply(context, args);
            timer = null;
        }, t)
    }
}

function isBigClientVersion(otherVersion) {
    var mat = (navigator.userAgent || navigator.wxuserAgent || str).match(/MicroMessenger\/([\d\.]+)/i),
        version = '';

    if (mat && mat.length > 1) {
        version = mat[1];
    } else {
        return false;
    }

    version = version.split('.');
    otherVersion = otherVersion.split('.');

    for (var i = 0; i < version.length && i < otherVersion.length; i++) {
        if ((+version[i] || 0) > (+otherVersion[i] || 0)) {
            return true;
        } else if ((+version[i] || 0) < (+otherVersion[i] || 0)) {
            return false;
        }
    }
    return false;
}

/**
 *  ajax 请求
 *  @public
 *  @param  url 请求的url， 不要带参数
 *  @param  params 请求的传递的参数，keyvalue模式或者json字符串
 *  @param  onSuccess 成功的回调
 *  @param  onFail 失败的回调
 *  @param  options {method: 'GET', timeout: 30000}
 *  不同于ajaxcall，是普通的ajax请求
 */
export function ajax(url, params, onSuccess, onFail, options) {
    if(typeof options === 'function'){
        var onTimeout = options;
    }else if(typeof options === 'object'){
        var option = extend({method: 'GET', timeout: 15000}, options);
        onTimeout = arguments[5];
    }else{
        option = {};
    }

    
    this._QMAjax = new Ajax(url, option.method, option.timeout);
    var t0 = (new Date()).getTime();
    this._QMAjax.onComplete = function(xhr) {
        var res = {};
        // 过滤特殊字符
        var temp = (xhr.responseText || '').replace(/[\u0000-\u001f\u000B\u000C\u00A0\uFEFF\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u202E\u202D]/g, '');
        try {
            res = JSON.parse(temp);
        } catch (e) {
            try {
                res = new Function('return ' + temp)();
            } catch (e) {
                res = {};
            }
        }
        onSuccess && onSuccess(res);
        var t1 = (new Date()).getTime();
    };
    this._QMAjax.onError = function(xhr, errcode) {
        if ('ok' !== errcode) {
            onFail && onFail(errcode);
        }                
        var res = {};
        try {
            res = JSON.parse(xhr.responseText)
        } catch (e) {
            res = {responseText: xhr.responseText};
        }
        var t1 = (new Date()).getTime();
    };
    this._QMAjax.onTimeout = onTimeout;

    if ('string' === typeof params) {
        this._QMAjax.send(params);
    } else {
        this._QMAjax.send(Str.mapToStr(params));
    }
    return this._QMAjax;
}

export default {
    ajaxRequest : _ajaxCall,
    ajaxCall    : _ajaxCall,
    getQueryStr : Base.getQueryStr,
    mapToStr    : Str.mapToStr,
    extend      : extend,
    tmpl        : Str.format,
    filterXSS   : Str.filterXSS,
    clientInfo  : getClientInfo(),
    openWithWebView: wxBridge.openUrl,
    setTitle    : setTitle,
    throttle    : throttle,
    debounce    : debounce,
    filterImg   : Str.filterImg,
    filterUrlByKey  : Str.filterUrlByKey,
    extendDeep  : extendDeep,
    UI          : UI,
    ajax        : ajax,
};
export const ajaxRequest = _ajaxCall;
export const ajaxCall = _ajaxCall;
export const getQueryStr = Base.getQueryStr;
export const mapToStr = Str.mapToStr;
export const tmpl = Str.format;
export const filterXSS = Str.filterXSS;
export const filterImg = Str.filterImg;

export const filterUrlByKey = Str.filterUrlByKey;

export const clientInfo = getClientInfo();
export const openWithWebView = wxBridge.openUrl;

